/* npx-produktpanel: produktsidan glider in som en panel över rutnätet (Jacob 2026-10-22).
   Rutnätet ligger kvar orört bakom, så positionen följer med. Adressen byts till produktens riktiga adress
   (pushState), så länken går att dela och Google ser samma sidor som förut. Bakåtknappen, pilen, Esc och klick
   på det tonade fältet stänger. En direkt laddning av en produktadress visar hela produktsidan som vanligt.
   Innehållet hämtas med fetch: sidans <main> läggs i panelen, saknade stilmallar och skript läggs till, och
   skripten i <main> körs om. Pixifys block-product-details.js startar bara en gång per laddning (den letar upp
   .pi-product-details när filen körs), så den laddas om med en egen parameter varje gång en ny produkt öppnas.
   Pixify skriver själv över historikposten med replaceState({}), därför avgörs läget på adressen, inte på state.
   "Lägg i kundvagn" läggs i varukorgen med fetch och varukorgslådan öppnas, i stället för att sidan byts till /cart.
   Går något fel öppnas produktsidan som en vanlig sida. */
(function () {
  "use strict";
  if (window.__npxProduktpanel) return;
  window.__npxProduktpanel = true;
  if (!document.querySelector("[data-npx-grid]")) return;

  var me = document.currentScript;
  var T = {
    tillbaka: (me && me.getAttribute("data-tillbaka")) || "Back to the images",
    laddar: (me && me.getAttribute("data-laddar")) || "Loading",
  };
  var html = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var rot, ark, inne, tillbakaBtn;
  var oppen = false, egenPost = false, rutnatTitel = document.title, senaste = null, kor = 0, pixifyN = 0, aktivUrl = "";

  function arProdukt(u) {
    try { return /\/products\/[^/?#]+/.test(new URL(u, location.href).pathname); } catch (e) { return false; }
  }
  function sammaSajt(u) {
    try { return new URL(u, location.href).origin === location.origin; } catch (e) { return false; }
  }
  function utanVariant(u) {
    var x = new URL(u, location.href); x.hash = ""; x.searchParams.delete("variant"); return x.pathname + x.search;
  }

  function bygg() {
    if (rot) return;
    rot = document.createElement("div");
    rot.className = "npx-pp";
    rot.hidden = true;
    rot.innerHTML =
      '<div class="npx-pp__dim" data-npx-pp-stang></div>' +
      '<section class="npx-pp__ark" role="dialog" aria-modal="true" tabindex="-1">' +
      '<div class="npx-pp__topp"><button type="button" class="npx-pp__tillbaka" data-npx-pp-stang>' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg><span></span></button></div>' +
      '<div class="npx-pp__inne"></div></section>';
    document.body.appendChild(rot);
    ark = rot.querySelector(".npx-pp__ark");
    inne = rot.querySelector(".npx-pp__inne");
    tillbakaBtn = rot.querySelector(".npx-pp__tillbaka");
    tillbakaBtn.querySelector("span").textContent = T.tillbaka;
    ark.setAttribute("aria-label", T.tillbaka);
    rot.addEventListener("click", function (e) {
      if (e.target.closest("[data-npx-pp-stang]")) { e.preventDefault(); stangViaHistorik(); }
    });
    // Köp i panelen: lägg i varukorgen och öppna lådan, som korten gör (snippets/npx-card-actions.liquid).
    inne.addEventListener("submit", function (e) {
      var f = e.target;
      if (!f || !/\/cart\/add/.test(f.getAttribute("action") || "")) return;
      e.preventDefault();
      laggIVarukorg(f);
    });
  }

  function laggIVarukorg(f) {
    var btn = f.querySelector('[type="submit"]');
    btn && (btn.disabled = true, btn.classList.add("is-busy"));
    var drawer = document.querySelector("cart-drawer");
    var fd = new FormData(f), sections = [];
    try {
      if (drawer && typeof drawer.getSectionsToRender === "function")
        sections = drawer.getSectionsToRender().map(function (s) { return s.section; });
    } catch (err) { sections = []; }
    if (sections.length) { fd.append("sections", sections.join(",")); fd.append("sections_url", location.pathname); }
    fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: fd })
      .then(function (r) { if (!r.ok) throw new Error("http " + r.status); return r.json(); })
      .then(function (json) {
        if (drawer && json.sections && typeof drawer.renderContents === "function") drawer.renderContents(json, true);
        else if (drawer && typeof drawer.open === "function") drawer.open();
        else location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || "/") + "cart";
      })
      .catch(function () { f.submit(); })
      .then(function () { btn && (btn.disabled = false, btn.classList.remove("is-busy")); });
  }

  // Lås sidan bakom utan att bredden ändras (rutnätet packar om raderna om bredden ändras).
  function las(pa) {
    if (pa) {
      var sb = window.innerWidth - html.clientWidth;
      html.style.setProperty("--npx-pp-sb", sb + "px");
      html.classList.add("npx-pp-las");
    } else {
      html.classList.remove("npx-pp-las");
      html.style.removeProperty("--npx-pp-sb");
    }
  }

  // Rutnätets läge när panelen öppnas: rutan överst i fönstret och dess höjd. Produktsidans sektioner har
  // globala regler (till exempel .cc-custom-liquid { display: none }) som kan flytta sidan medan panelen är öppen,
  // så läget läggs tillbaka efter att innehållet tagits bort.
  var ankare = null;
  function sparaAnkare() {
    ankare = { y: window.scrollY, el: null, top: 0 };
    var list = document.querySelectorAll("[data-npx-grid] .npx-card");
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      if (r.bottom > 80) { ankare.el = list[i]; ankare.top = r.top; break; }
    }
  }
  function aterstallAnkare() {
    if (!ankare) return;
    var y = ankare.el && ankare.el.isConnected ? window.scrollY + ankare.el.getBoundingClientRect().top - ankare.top : ankare.y;
    window.scrollTo(0, Math.max(0, Math.round(y)));
    ankare = null;
  }

  function visa() {
    bygg();
    if (oppen) return;
    oppen = true;
    sparaAnkare();
    senaste = document.activeElement;
    rot.hidden = false;
    las(true);
    // två bildrutor så att övergången startar från stängt läge
    requestAnimationFrame(function () { requestAnimationFrame(function () { rot.classList.add("is-oppen"); }); });
    ark.focus({ preventScroll: true });
  }

  function stang() {
    if (!oppen) return;
    oppen = false;
    kor++;
    rot.classList.remove("is-oppen");
    document.title = rutnatTitel;
    aktivUrl = "";
    var klar = function () {
      if (oppen) return;
      rot.hidden = true;
      inne.innerHTML = "";
      las(false);
      aterstallAnkare();
    };
    reduce ? klar() : setTimeout(klar, 360);
    if (senaste && senaste.focus) try { senaste.focus({ preventScroll: true }); } catch (e) {}
  }

  function stangViaHistorik() {
    if (egenPost && arProdukt(location.href)) history.back();
    else {
      stang();
      if (arProdukt(location.href)) history.replaceState(null, "", rutnatUrl || "/");
    }
  }

  var rutnatUrl = location.href;

  function laddaStil(doc) {
    var har = {};
    document.querySelectorAll('link[rel="stylesheet"]').forEach(function (l) { har[l.href] = 1; });
    var vanta = [];
    doc.querySelectorAll('link[rel="stylesheet"]').forEach(function (l) {
      var href = new URL(l.getAttribute("href"), location.href).href;
      if (har[href]) return;
      har[href] = 1;
      var n = document.createElement("link");
      n.rel = "stylesheet"; n.href = href; if (l.media) n.media = l.media;
      vanta.push(new Promise(function (ok) { n.onload = n.onerror = ok; }));
      document.head.appendChild(n);
    });
    return Promise.race([Promise.all(vanta), new Promise(function (ok) { setTimeout(ok, 1500); })]);
  }

  function laddaSkript(src, omkor) {
    return new Promise(function (ok) {
      var abs = new URL(src, location.href).href;
      if (!omkor && document.querySelector('script[src="' + src + '"], script[src="' + abs + '"]')) return ok();
      var s = document.createElement("script");
      if (omkor) { var u = new URL(abs); u.searchParams.set("npxpp", String(++pixifyN)); abs = u.href; }
      s.src = abs; s.async = false;
      s.onload = s.onerror = function () { ok(); };
      document.body.appendChild(s);
    });
  }

  // Skript som körs om vid varje ny produkt (de startar bara en gång per laddning).
  function omkors(src) { return /\/extensions\/.*\/assets\/block-[a-z-]+\.js/.test(src); }

  function korSkript(doc, main) {
    // 1. externa skript i sidan som inte finns här, i ordning; Pixifys block körs om
    var kedja = Promise.resolve();
    var sedda = {};
    doc.querySelectorAll("script[src]").forEach(function (s) {
      var src = s.getAttribute("src");
      if (!src || sedda[src]) return;
      sedda[src] = 1;
      if (/(shopify_pay|portable-wallets|trekkie|shop_events|web-pixels|preview_bar|perf-kit|instant-page)/.test(src)) return;
      var om = omkors(src);
      kedja = kedja.then(function () { return laddaSkript(src, om); });
    });
    // 2. inline-skripten i <main> i ordning (innerHTML kör dem inte)
    return kedja.then(function () {
      main.querySelectorAll("script").forEach(function (gammal) {
        var typ = (gammal.getAttribute("type") || "").toLowerCase();
        if (typ && typ !== "text/javascript" && typ !== "module" && typ !== "application/javascript") return;
        if (gammal.src) { gammal.remove(); return; }
        var n = document.createElement("script");
        for (var i = 0; i < gammal.attributes.length; i++) n.setAttribute(gammal.attributes[i].name, gammal.attributes[i].value);
        n.textContent = gammal.textContent;
        try { gammal.replaceWith(n); } catch (e) {}
      });
    });
  }

  function oppna(url, push) {
    if (!arProdukt(url)) return;
    var nyckel = utanVariant(url);
    if (oppen && nyckel === aktivUrl) return;
    var mitt = ++kor;
    if (push) {
      // Första produkten får en egen historikpost; en produkt öppnad inifrån panelen (Liknande klipp) ersätter
      // den, så att Tillbaka och bakåtknappen alltid leder till rutnätet i ett steg.
      if (oppen && egenPost) history.replaceState({ npxpp: 1 }, "", url);
      else { rutnatUrl = location.href; history.pushState({ npxpp: 1 }, "", url); egenPost = true; }
    }
    aktivUrl = nyckel;
    visa();
    rot.classList.add("is-laddar");
    inne.setAttribute("aria-busy", "true");
    inne.innerHTML = '<div class="npx-pp__laddar" role="status"><span class="npx-pp__snurr"></span><span class="visually-hidden">' + T.laddar + "</span></div>";
    ark.scrollTop = 0;

    fetch(url, { headers: { "X-Requested-With": "fetch" }, credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error("http " + r.status); return r.text(); })
      .then(function (txt) {
        if (mitt !== kor) return;
        var doc = new DOMParser().parseFromString(txt, "text/html");
        var main = doc.querySelector("#main-content") || doc.querySelector("main");
        if (!main || !main.querySelector(".pi-product-details, form[action*='/cart/add']")) throw new Error("ingen produkt");
        return laddaStil(doc).then(function () {
          if (mitt !== kor) return;
          var crumbs = main.querySelector(".product-breadcrumbs");
          crumbs && crumbs.remove();
          inne.innerHTML = "";
          var wrap = document.createElement("div");
          wrap.className = "npx-pp__sida";
          wrap.id = "main-content-pp";
          while (main.firstChild) wrap.appendChild(document.adoptNode(main.firstChild));
          // Stilmallar inne i sektionerna (Liknande klipp har med sig npx-explore.css) skulle hamna sist i ordningen
          // och slå npx-sand.css, så att rutnätet bakom flyttar sig. De som behövs ligger redan i head (laddaStil).
          wrap.querySelectorAll('link[rel="stylesheet"]').forEach(function (l) { l.remove(); });
          inne.appendChild(wrap);
          // Video som flyttats in från ett hämtat dokument laddar inte av sig själv: ladda och starta (som på sidan).
          wrap.querySelectorAll("video").forEach(function (v) {
            v.muted = v.hasAttribute("muted");
            try { v.load(); } catch (e) {}
            if (v.hasAttribute("autoplay")) { var pr = v.play(); pr && pr.catch && pr.catch(function () {}); }
          });
          if (doc.title) document.title = doc.title;
          rot.classList.remove("is-laddar");
          inne.removeAttribute("aria-busy");
          return korSkript(doc, wrap);
        });
      })
      .catch(function () {
        if (mitt !== kor) return;
        location.href = url; // fallback: vanlig sidladdning
      });
  }

  // Klick på ett kort i rutnätet, och på produktlänkar inne i panelen (Liknande klipp).
  document.addEventListener("click", function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest("a[href]");
    if (!a || a.target === "_blank" || a.hasAttribute("download")) return;
    if (e.target.closest("[data-npx-dl],[data-npx-cart],[data-npx-fav],.npx-act")) return;
    var href = a.getAttribute("href");
    if (!sammaSajt(href) || !arProdukt(href)) return;
    var iRutnat = a.closest("[data-npx-grid]") && !a.closest(".npx-pp");
    var iPanel = oppen && a.closest(".npx-pp__inne");
    if (!iRutnat && !iPanel) return;
    e.preventDefault();
    oppna(a.href, true);
  });

  document.addEventListener("keydown", function (e) {
    if (oppen && e.key === "Escape" && !document.querySelector("cart-drawer[open], .drawer[open], dialog[open]")) {
      e.preventDefault();
      stangViaHistorik();
    }
  });

  window.addEventListener("popstate", function () {
    if (arProdukt(location.href)) { egenPost = true; oppna(location.href, false); }
    else if (oppen) stang();
  });

  // Rutnätssidan återställd ur bfcache med en produktadress kvar i fältet: visa panelen igen.
  window.addEventListener("pageshow", function (e) {
    if (e.persisted && arProdukt(location.href) && !oppen) oppna(location.href, false);
  });

  window.npxProduktpanel = { oppna: function (u) { oppna(u, true); }, stang: stangViaHistorik };
})();
